import GeoJSON from "ol/format/GeoJSON";
import { getStyle } from "@/viewer/helper";

export function mapSlideStatus(status) {
  console.log("status", status);
  if (status === undefined) {
    return "No annotation requested.";
  }
  if (status.status === "assigned") {
    return "Assigned";
  }
  if (status.status === "annotations_requested") {
    return "Annotations requested";
  }

  return `Unknown: ${status}`;
}

export function mapAnnotationStatus(status) {
  return status.charAt(0).toUpperCase() + status.substr(1);
}

const geoJson = new GeoJSON();

export function observationToAnnotation(rawAnnotation) {
  console.log(rawAnnotation);
  const observation = rawAnnotation.observation;
  const annotationClassId = observation.code.coding[0].code;
  const component = system =>
    observation.component.filter(e => e.code.coding[0].system === system);

  const type = component("http://deeppat.cl/code-system/annotation-type")[0]
    .code.coding[0].code;
  const coordinates = component("http://deeppat.cl/code-system/annotations");
  const length = coordinates.length / 2; // number is even bc of coordinate pairs
  const coordinate = pair =>
    observation.component.filter(
      e =>
        e.modifierExtension !== undefined &&
        e.modifierExtension[0].valueInteger === pair
    );
  const y = pair => pair.find(e => e.code.coding[0].code === "y");
  const x = pair => pair.find(e => e.code.coding[0].code === "x");

  const feature = {};
  const coordinatePairs = [];
  for (let i = 0; i < length; ++i) {
    let pair = coordinate(i);

    // we can only store integers in observations so divide by 100 to restore floats (only 2 decimals)
    coordinatePairs.push([
      x(pair).valueInteger / 100,
      y(pair).valueInteger / 100
    ]);
  }
  feature.type = "Feature";
  let coordinateArr = [coordinatePairs];
  if (type === "LineString") coordinateArr = coordinatePairs;
  feature.geometry = {
    type,
    coordinates: coordinateArr
  };
  feature.properties = {
    FEATURE_OBSERVATION_ID: observation.id,
    FEATURE_STATUS: rawAnnotation.status,
    FEATURE_ANNOTATION_ID: rawAnnotation.id,
    FEATURE_STYLE: getStyle(
      type,
      rawAnnotation.annotation_class.fill_color,
      rawAnnotation.annotation_class.color
    )
  };

  return {
    feature: geoJson.readFeature(feature),
    annotationClassId,
    id: observation.id,
    rawAnnotation
  };
}

export function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    let r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
